$(document).ready(function () {
  Sceon.Scroll = {};
  Sceon.Scroll.isRunning = false;
  Sceon.Scroll.finish = false;
  Sceon.Scroll.page = 1;
  Sceon.Scroll.loader = null;

  Sceon.Scroll.init = function ({ page }) {
    Sceon.Scroll.page = page || 1;
    if ($('.infinity-scroll-container').length) {
      Sceon.Scroll.scroll();
    } else if (location.pathname.includes('gps-location')) {
      checkContainer();
    }
  };

  Sceon.Scroll.scroll = function () {
    $(window).scroll(function () {
      let perPage = +$('.main-listing-container .loader').attr('data-per-page');
      let count = +$('.escorts-list .escort-item').length;
      if (count < perPage * Sceon.Scroll.page) {
        return;
      }

      if (Sceon.Scroll.isRunning || Sceon.Scroll.finish) {
        return;
      }

      function isOnScreen() {
        const element = $('.main-listing-container .loader');

        if (!element.get(0)) {
          return false;
        }

        const top_of_element = element.offset().top + 50;
        const bottom_of_element = top_of_element + element.outerHeight();
        const bottom_of_screen =
          $(window).scrollTop() + $(window).innerHeight();
        const top_of_screen = $(window).scrollTop();

        return (
          bottom_of_screen > top_of_element && top_of_screen < bottom_of_element
        );
      }

      if (isOnScreen()) {
        Sceon.Scroll.isRunning = true;
        $('.main-listing-container .loader').addClass('loader-active');
        Sceon.Scroll.loader = new Sceon.Overlay(
          $('.main-listing-container .loader'),
          {
            loader: '/img/loader-tiny.gif',
            offset: { bottom: 0, top: 0 },
          },
        );
        Sceon.Scroll.loader.enable();
        Sceon.Scroll.loadEscorts();
      }
    });
  };

  Sceon.Scroll.loadEscorts = function () {
    Sceon.Filter.Set(
      {
        page: [Sceon.Scroll.page + 1],
      },
      true,
    );
  };

  Sceon.Scroll.onSuccess = function ({ escortList: resp }) {
    let perPage = +$('.main-listing-container .loader').attr('data-per-page');
    const newEscorts = $(resp)
      .find('.escort-item')
      .filter(function (index) {
        const start = (Sceon.Scroll.page - 1) * perPage;
        const end = start + perPage;
        return index >= start && index < end;
      });
    let escCount = $(newEscorts).length;

    const newElementsByClass = (className) => {
      const existingIds = new Set(
        $(`.escorts-list ${className}`)
          .map(function () {
            return this.id;
          })
          .get(),
      );

      return $(resp)
        .find(className)
        .filter(function () {
          return this.id && !existingIds.has(this.id);
        });
    };

    if (escCount > 0) {
      if (escCount < perPage) {
        Sceon.Scroll.finish = true;
      }
      $('.escorts-list')
        .append(newEscorts)
        .append(newElementsByClass('.banner-group-mobile'));
    } else {
      Sceon.Scroll.finish = true;
    }
    Sceon.Scroll.isRunning = false;
    $('.main-listing-container .loader').removeClass('loader-active');
    Sceon.Scroll.loader?.disable();
    Sceon.PhotoRoller.init();
  };

  Sceon.Scroll.onError = function (error) {
    console.error('err', error);
  };

  Sceon.Scroll.removeScroll = function () {
    $(window).unbind('scroll');
  };

  function checkContainer() {
    setTimeout(() => {
      if ($('.infinity-scroll-container').length) {
        Sceon.Scroll.scroll();
      } else {
        checkContainer();
      }
    }, 200);
  }
});
